<tui-textfield iconStart="@tui.search" [tuiTextfieldSize]="size" [tuiTextfieldCleaner]="true">
  <input
    tuiTextfield
    [placeholder]="'common.fields.search' | translate"
    [(ngModel)]="searchQuery"
    (ngModelChange)="searchQueryChangeHandler($event)"
  />
</tui-textfield>
